export default "__VITE_ASSET__1d2ea0f2__"